export function findFooterContentValue(items, type) {
  if (!Array.isArray(items)) {
    return '';
  }

  const value = items.find((content) => content.type === type)?.value;
  return typeof value === 'string' ? value.trim() : '';
}

export function parseFooterContents(items) {
  return {
    addressLao: findFooterContentValue(items, 'address_lao'),
    addressEnglish: findFooterContentValue(items, 'address_english'),
    footerLao: findFooterContentValue(items, 'footer_lao'),
    footerEnglish: findFooterContentValue(items, 'footer_english'),
  };
}

export function pickLocalizedFooterText(laoText, englishText, language) {
  const isLao = language === 'la';
  const primary = isLao ? laoText : englishText;
  const secondary = isLao ? englishText : laoText;
  return primary || secondary || '';
}

export function resolveFooterAddress(contents, language, fallback) {
  const localized = pickLocalizedFooterText(
    contents.addressLao,
    contents.addressEnglish,
    language
  );
  return localized || fallback || '';
}

export function resolveFooterAbout(contents, language, fallback) {
  const localized = pickLocalizedFooterText(
    contents.footerLao,
    contents.footerEnglish,
    language
  );
  return localized || fallback || '';
}
